import { AdminContentCategory } from './admin';

// Mirrors the sort modes the /search endpoint accepts.
export const SEARCH_SORT_MODES = ['relevance', 'newest', 'oldest'] as const;
export type SearchSortMode = (typeof SEARCH_SORT_MODES)[number];

export const SEARCH_SORT_LABELS: Record<SearchSortMode, string> = {
  relevance: 'Relevance',
  newest: 'Newest',
  oldest: 'Oldest',
};

export interface SearchHit {
  key: string;
  title: string;
  category: AdminContentCategory;
  date: string | null;
  score: number;
  // Sentinel-delimited fragments of the document text. Never HTML, so split,
  // never innerHTML. [] when the match was on title alone.
  snippets: string[];
}

// Must match SNIPPET_TAGS in middle-layer/src/search/opensearch.ts. Control
// characters rather than <em>: extraction decodes entities, so any
// markup-shaped delimiter could collide with the document's own text.
export const SNIPPET_PRE = '\u0000';
export const SNIPPET_POST = '\u0001';

export interface SearchResponse {
  status?: string;
  page?: number;
  perPage?: number;
  hasNextPage?: boolean;
  total?: number;
  data?: SearchHit[];
  error?: string;
}
